import React, { useContext } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { ContentfulContext } from '../context/Contentful';
import { useBrandDetails } from 'dw-au-react-components';

const StyledPlpSeoTop = styled.div`
	.plp_seo__background {
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;

		@media (min-width: 576px) {
			background: ${(props) =>
				`#${
					props.tag === 'vir'
						? '2D054E'
						: props.tag === 'adc'
						? '074A67'
						: '00193C'
				} url(${props.bannerImage})`};
			background-size: cover;
			min-height: ${(props) => (props.copy ? '180px' : '150px')};
			padding: 32px 82px;
		}

		@media (max-width: 767px) and (min-width: 576px) {
			padding: 32px !important;
		}

		@media (max-width: 575px) {
			background: ${(props) =>
				`#${
					props.tag === 'vir'
						? '2D054E'
						: props.tag === 'adc'
						? '074A67'
						: '00193C'
				} url(${props.bannerImageMobile})`};
			background-size: cover;
			min-height: ${(props) => (props.copy ? '200px' : '120px')};
			padding: 32px 16px;
		}
	}

	.plp_seo__short-copy {
		a {
			color: white;
			text-decoration: underline;
			transition: opacity 0.3s ease;

			&:hover {
				opacity: 0.7;
			}
		}
	}

	.plp_seo__cta a:hover {
		color: #212121 !important;
	}
`;

const PlpSeoTop = ({ searchHeading }) => {
	const { tag, name } = useBrandDetails();
	const { plpSeoCopy, wineType } = useContext(ContentfulContext);
	let bannerImage =
			plpSeoCopy?.banner?.fields?.file?.url ??
			'/images/au/common/wines/heading/' + wineType + '.jpg',
		bannerImageMobile =
			plpSeoCopy?.bannerMobile?.fields?.file?.url ??
			'/images/au/common/wines/heading/' + wineType + '-mobile.jpg';

	const updateMetaDescription = () => {
		const metaDescription = document.querySelector('meta[name="description"]'),
			metaOgTitle = document.querySelector('meta[property="og:title"]'),
			metaOgDescription = document.querySelector(
				'meta[property="og:description"]'
			);
		if (metaDescription && plpSeoCopy?.metaDescription) {
			metaDescription.setAttribute('content', plpSeoCopy?.metaDescription);
			metaOgDescription.setAttribute('content', plpSeoCopy?.metaDescription);
		}

		if (metaOgTitle && plpSeoCopy?.metaTitle) {
			metaOgTitle.setAttribute('content', `${plpSeoCopy?.metaTitle} - ${name}`);
		}
	};

	return (
		<StyledPlpSeoTop
			bannerImage={bannerImage}
			bannerImageMobile={bannerImageMobile}
			copy={plpSeoCopy?.shortCopy ?? null}
			brandTag={tag}
		>
			<Helmet onChangeClientState={() => updateMetaDescription()}>
				{plpSeoCopy?.metaTitle ? (
					<title>
						{plpSeoCopy?.metaTitle} - {name}
					</title>
				) : null}
			</Helmet>
			<div className='plp_seo__background'>
				<h1
					className={`search-heading mb-16 text-white text-center ${
						tag === 'vir' ? 'lower medium' : ''
					}`}
				>
					{plpSeoCopy?.title ? plpSeoCopy?.title : searchHeading}
				</h1>
				<span className='pb-8 d-none d-sm-block'></span>
				{plpSeoCopy?.shortCopy ? (
					<div className='plp_seo__short-copy text-center'>
						<div
							className='text-white mb-0 font-weight-bold text-big d-none d-sm-inline-block'
							dangerouslySetInnerHTML={{
								__html: plpSeoCopy?.shortCopy
							}}
						></div>
						<div
							className='text-white mb-0 font-weight-bold d-inline-block d-sm-none'
							dangerouslySetInnerHTML={{
								__html: plpSeoCopy?.shortCopy
							}}
						></div>
					</div>
				) : null}
				{plpSeoCopy?.buttons && plpSeoCopy?.buttons?.items.length > 0 ? (
					<div className='mt-20 d-flex justify-content-center align-items-center flex-wrap plp_seo__cta'>
						{plpSeoCopy?.buttons?.items.map(({ title, link, index }) => {
							return (
								<a
									href={link}
									title={title}
									key={index}
									className='btn btn-outline-white m-12'
								>
									{title}
								</a>
							);
						})}
					</div>
				) : null}
			</div>
		</StyledPlpSeoTop>
	);
};

export default PlpSeoTop;
